<template>
  <div class="latest-reports">
    <div
      v-show="!hideTitle"
      class="header"
    >
      <router-link
        to="reports"
      >
        <img
          class="redirect-icon"
          src="/dashboard/routeTo.svg"
        >
      </router-link>
    </div>

    <div class="reports-list">
      <Report
        v-for="report in latestReports"
        :key="report.id"
        :report="report"
      />
    </div>

    <div
      v-if="latestReports.length < 1"
      class="no-reports"
    >
      {{ $t('siteDashboard.noReports') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Report from './Report.vue';


export default {
    name: 'LatestReports',

    components: {
        Report,
    },

    props: {
        hideTitle: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: false,
            reports: [],
        };
    },

    computed: {
        ...mapGetters([
            'lang',
            'site',
        ]),

        latestReports() {
            return this.reports.slice(0, 3);
        },
    },

    created() {
        this.getSiteReports();
    },

    methods: {
        async getSiteReports() {
            this.loading = true;

            const { data } = await this.$rq.getSiteReports(this.site.id, { reportType: 'service' });
            this.reports = data.reports;

            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.latest-reports {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height:100%;
    width: 100%;
    background: #FFF;
    border-radius: 7px;
    margin-top: 10px;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 6px;
        background: #DEDEDE;
        border-radius: 7px 7px 0px 0px;
    }

    h3 {
        display: flex;
        justify-content: center;
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        text-transform: capitalize;
        text-align: center;
    }

    .redirect-icon {
        display: flex;
        width: 16px;
        height: 16px;
    }

    .reports-list {
        width: 100%;
    }

    .no-reports {
        padding: 20px;
        color: rgba(20, 20, 20, 0.25);
        font-size: 12px;
        text-align: center;

    }
}

</style>
